import { ReactElement, ReactNode } from "react";

import { GenericExperienceFe } from "@intelligems/ig-types";
import {
  useCanCrateExperience,
  useCanStartExperience,
} from "@src/components/LimitAccess/experiment-scope-hooks";
import { ScopedComponentWithDisable } from "@src/components/LimitAccess/ScopedComponentWithDisable";

interface ScopedCreateExperienceWithDisabledProps {
  experience: GenericExperienceFe;
  debugId: string;
  adminDisable?: boolean;
  customDisabledTooltipMessage?: string;
  customEnabledTooltipMessage?: ReactNode;
  additionalEnableRequirements?: boolean[];
  children: ReactElement<{
    disabled: boolean;
    onClick?: () => void;
    onChange?: () => void;
  }>;
}

export const ScopedCreateExperienceWithDisabled = ({
  experience,
  adminDisable,
  children,
  customDisabledTooltipMessage,
  debugId,
  additionalEnableRequirements,
  customEnabledTooltipMessage,
}: ScopedCreateExperienceWithDisabledProps) => {
  const { canCreate, disabledMessage } = useCanCrateExperience(experience);

  return (
    <ScopedComponentWithDisable
      debugId={debugId}
      adminDisable={adminDisable}
      customDisabledTooltipMessage={
        customDisabledTooltipMessage || disabledMessage
      }
      isEnabled={Boolean(
        canCreate &&
          (additionalEnableRequirements?.length
            ? additionalEnableRequirements.every((r) => !!r)
            : true)
      )}
      customEnabledTooltipMessage={customEnabledTooltipMessage}
    >
      {children}
    </ScopedComponentWithDisable>
  );
};
